<h2 class="thm-page-title ng-star-inserted"> Ödeme Sonuç </h2>

<thm-alert type="light" class="mt-2">

  <h6 class="alert-heading text-danger"><i class="fas fa-times" aria-hidden="true"></i> Ödeme İşlemi BAŞARISIZ! </h6>

  <hr style="margin: 10px 0 10px 0">

  <div class="block mb-0 mt-2" style="font-weight: 600;">
    <div class="headline">
      Ödeme işlemi başarısız. Anasayfaya dönmek için
      <thm-button buttonType="primary" buttonSize="sm" class="mr-1" [routerLink]="['/']">
        TIKLAYINIZ
      </thm-button>
    </div>
  </div>

</thm-alert>